<template>
  <div class="user-main">
    <div class="user-form">
      <div class="steps one">
        <div class="steps-line-box">
          <div class="steps-line" style="width:35%;"></div>
        </div>
        <ul class="steps-ul">
          <li class="active">{{ $t("lang.steps1") }}</li>
          <li>{{ $t("lang.steps2") }}</li>
          <li>{{ $t("lang.steps3") }}</li>
          <li>{{ $t("lang.steps4") }}</li>
        </ul>
      </div>
      <div v-if="!emailSend">
        <div class="user-form-img">
          <img src="~assets/images/pic_02@2x.png" alt="" />
        </div>
        <div v-if="language === 'cn'">
          <el-form
            ref="registerForm"
            :model="registerForm"
            autoComplete="off"
            :rules="formRules"
          >
            <div class="form-box">
              <div class="form-group">
                <el-form-item prop="mobile">
                  <el-input
                    v-model="registerForm.mobile"
                    type="text"
                    placeholder="手机号"
                    auto-complete="off"
                  ></el-input>
                </el-form-item>
              </div>
              <div class="form-group">
                <el-form-item prop="password">
                  <el-input
                    :key="passwordType"
                    ref="password"
                    v-model="registerForm.password"
                    :type="passwordType"
                    placeholder="密码"
                    auto-complete="off"
                  ></el-input>
                  <span class="show-pwd" @click="showPwd">
                    <i v-if="passwordType === 'password'" class="eye-close" />
                    <i v-if="passwordType !== 'password'" class="eye-open" />
                  </span>
                </el-form-item>
              </div>
              <div class="form-group">
                <el-form-item prop="checkPass">
                  <el-input
                    v-model="registerForm.checkPass"
                    :type="passwordType"
                    placeholder="确认密码"
                    auto-complete="off"
                  ></el-input>
                </el-form-item>
              </div>
              <el-button
                class="btn"
                :loading="btnLoading"
                @click="getSmsCode"
                >{{ $t("lang.loginPage28") }}</el-button
              >
              <p>
                {{ $t("lang.loginPage16") }}
                <router-link to="/login" tag="a">{{
                  $t("lang.loginPage7")
                }}</router-link>
                {{ $t("lang.loginPage4") }}
              </p>
            </div>
          </el-form>
        </div>
        <div v-else>
          <el-form
            ref="registerForm"
            :model="registerForm"
            autoComplete="off"
            :rules="formRules"
          >
            <div class="form-box">
              <div class="form-group">
                <el-form-item prop="email">
                  <el-input
                    v-model="registerForm.email"
                    type="text"
                    :placeholder="$t('lang.loginPage8')"
                    auto-complete="off"
                  ></el-input>
                </el-form-item>
              </div>
              <div class="form-group">
                <el-form-item prop="password">
                  <el-input
                    :key="passwordTypeEn"
                    ref="passwordEn"
                    v-model="registerForm.password"
                    :type="passwordTypeEn"
                    :placeholder="$t('lang.loginPage9')"
                    auto-complete="off"
                  ></el-input>
                  <span class="show-pwd" @click="showPwdEn">
                    <i v-if="passwordTypeEn === 'password'" class="eye-close" />
                    <i v-if="passwordTypeEn !== 'password'" class="eye-open" />
                  </span>
                </el-form-item>
              </div>
              <div class="form-group">
                <el-form-item prop="checkPass">
                  <el-input
                    v-model="registerForm.checkPass"
                    :type="passwordTypeEn"
                    :placeholder="$t('lang.loginPage14')"
                    auto-complete="off"
                  ></el-input>
                </el-form-item>
              </div>
              <el-button
                class="btn"
                :loading="btnLoading"
                @click="handlerSendEmail(true)"
                >{{ $t("lang.loginPage28") }}</el-button
              >
              <p>
                {{ $t("lang.loginPage16") }}
                <router-link to="/login" tag="a">{{
                  $t("lang.loginPage7")
                }}</router-link>
                {{ $t("lang.loginPage4") }}
              </p>
            </div>
          </el-form>
        </div>
      </div>
      <div v-else>
        <div class="user-form-img">
          <img src="~assets/images/pic_03@2x.png" alt="" />
        </div>
        <div v-if="language === 'cn'" class="form-box">
          <div class="success-title">
            {{ $t("lang.loginPage29") }}<br /><br />我们已向你发送短信，请输入短信验证码以激活您的账户。<br />
          </div>
          <div class="verification-group">
            <input
              v-model.number="registerForm.verifyCode"
              type="text"
              :placeholder="$t('lang.loginPage13')"
              auto-complete="off"
              :maxlength="6"
            />
            <el-button @click="getSmsCodeAgain" :disabled=smsDisabled round class="get-code">{{smsDisabled ? countdown : '发送'}}</el-button>
            <!-- <div class="btn btn-disabled" v-if="isEmailSend">
              {{ timeCount }}s
            </div>
            <el-button
              class="btn"
              :loading="btnLoading"
              @click="handlerSendEmail(false)"
              v-else
              >{{ $t("lang.loginPage27") }}</el-button
            > -->
          </div>
          <el-button
            class="btn"
            :loading="btnLoading"
            @click="handlerRegister"
            >{{ $t("lang.loginPage15") }}</el-button
          >
        </div>
        <div v-else class="form-box">
          <div class="success-title">
            {{ $t("lang.loginPage29") }}<br /><br />{{ $t("lang.loginPage30")
            }}<br /><span style="color:#ffa438">{{
              $t("lang.loginPage31")
            }}</span>
          </div>
          <div class="verification-group">
            <input
              v-model.number="registerForm.verifyCode"
              type="text"
              :placeholder="$t('lang.loginPage13')"
              auto-complete="off"
              :maxlength="6"
            />
            <div class="btn btn-disabled" v-if="isEmailSend">
              {{ timeCount }}s
            </div>
            <el-button
              class="btn"
              :loading="btnLoading"
              @click="handlerSendEmail(false)"
              v-else
              >{{ $t("lang.loginPage27") }}</el-button
            >
          </div>
          <el-button
            class="btn"
            :loading="btnLoading"
            @click="handlerRegister"
            >{{ $t("lang.loginPage15") }}</el-button
          >
        </div>
      </div>
    </div>
    <el-dialog
      title="滑动获取验证码"
      :show-close="false"
      :center="true"
      :width="'350px'"
      :top="'45vh'"
      :visible.sync="dialogSliderVisible"
    >
      <div class="code-slider">
        <nocaptcha
          :appkey="'FFFF0N0000000000662A'"
          :scene="'nc_login_h5'"
          :lang="'cn'"
          @callback="slideToGetCode"
        />
      </div>
    </el-dialog>
    <el-dialog
      class="registered-dialog"
      :show-close="false"
      :center="true"
      :top="'40vh'"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :visible.sync="dialogRegisteredVisible"
    >
      <div class="dialog-content">
        <div class="logo">
          <i class="el-icon-success"></i>
        </div>
        <div class="title">注册成功</div>
        <button class="login-btn" @click="handlerCloseDialog">立即登录</button>
      </div>
    </el-dialog>
    <div class="app-bg"></div>
  </div>
</template>

<script>
import { ERR_OK } from "api/config";
import { mapGetters } from "vuex";
import { register, sendActivateCode, slideToGetSmsCode } from "api/login";
import { nocaptcha } from 'vue-nocaptcha'
let vm = null;

export default {
  components: {
    nocaptcha
  },
  data() {
    const validateMobile = (rule, value, callback) => {
      if (!/^1[3|4|5|6|7|8|9][0-9]\d{4,8}$/.test(value)) {
        callback(new Error("请输入正确的手机号"));
      } else {
        callback();
      }
    }
    const validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error(vm.$t("lang.loginPage18")));
      } else {
        if (this.registerForm.password !== "") {
          this.$refs.registerForm.validateField("checkPass");
        }
        callback();
      }
    };
    const validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error(vm.$t("lang.loginPage19")));
      } else if (value !== this.registerForm.password) {
        callback(new Error(vm.$t("lang.loginPage20")));
      } else {
        callback();
      }
    };
    return {
      btnLoading: false,
      emailSend: false,
      isEmailSend: false,
      timeCount: "",
      timer: null,
      dialogSliderVisible: false,
      dialogRegisteredVisible: false,
      countdown: 60,
      smsDisabled: false,
      passwordType: 'password',
      passwordTypeEn: 'password',
      registerForm: {
        email: "",
        mobile: "",
        password: "",
        checkPass: "",
        verifyCode: ""
      },
      formRules: {
        email: [
          {
            required: true,
            type: "email",
            message: this.$t("lang.loginPage10"),
            trigger: "blur"
          }
        ],
        mobile: [
          {
            required: true,
            trigger: "blur",
            validator: validateMobile
          }
        ],
        password: [
          { validator: validatePass, trigger: "blur" },
          {
            min: 6,
            max: 14,
            message: this.$t("lang.loginPage11"),
            trigger: "blur"
          }
        ],
        verifyCode: [
          {
            required: true,
            message: '请输入验证码',
            trigger: "blur"
          }
        ],
        checkPass: [{ validator: validatePass2, trigger: "blur" }]
      }
    };
  },
  computed: {
    ...mapGetters(["language"])
  },
  created() {
    vm = this;
  },
  methods: {
    showPwd() {
      if (this.passwordType === 'password') {
        this.passwordType = ''
      } else {
        this.passwordType = 'password'
      }
      this.$nextTick(() => {
        this.$refs.password.focus()
      })
    },
    showPwdEn() {
      if (this.passwordTypeEn === 'password') {
        this.passwordTypeEn = ''
      } else {
        this.passwordTypeEn = 'password'
      }
      this.$nextTick(() => {
        this.$refs.passwordEn.focus()
      })
    },
    getCode() {
      const TIME_COUNT = 60;
      if (!this.timer) {
        this.timeCount = TIME_COUNT;
        this.isEmailSend = true;
        this.timer = setInterval(() => {
          if (this.timeCount > 0 && this.timeCount <= TIME_COUNT) {
            this.timeCount--;
          } else {
            this.isEmailSend = false;
            clearInterval(this.timer);
            this.timer = null;
          }
        }, 1000);
      }
    },
    getSmsCode() {
      this.$refs.registerForm.validate(valid => {
        if (valid) {
          const mobile = this.registerForm.mobile
          if (mobile === '') {
            this.$message.error('请输入手机号')
            return false
          } else if (!(/^\d+$/.test(mobile))) {
            this.$message.error('请输入手机号')
            return false
          } else if (!/^1[3|4|5|6|7|8|9][0-9]\d{4,8}$/.test(mobile)) {
            this.$message.error('请输入正确的手机号')
            return false
          }
          this.dialogSliderVisible = true
        } else {
          return false;
        }
      });
    },
    getSmsCodeAgain() {
      this.dialogSliderVisible = true
    },
    slideToGetCode(data) {
      const mobile = this.registerForm.mobile
      if (mobile === '') {
        this.$message.error('请输入手机号')
        data.nc.reset()
        return false
      } else if (!(/^\d+$/.test(mobile))) {
        this.$message.error('请输入手机号')
        data.nc.reset()
        return false
      }
      slideToGetSmsCode({
        smsCodeType: 'RIGESTER',
        sessionId: data.csessionid,
        token: data.token,
        scene: data.scene,
        sig: data.sig,
        mobile: '+86' + mobile
      }).then(response => {
        if (response.status !== 200) {
          data.nc.reset()
          this.list = []
          this.$message.error(response.data.message)
        } else {
          if (+response.data.code === 200) {
            this.countdown = 60
            this.smsDisabled = true
            setTimeout(this.tick, 1000)
            this.emailSend = true;
            this.dialogSliderVisible = false
            data.nc.reset()
          } else {
            data.nc.reset()
            this.$message.error(response.data.message)
          }
        }
      }).catch((e) => {
        console.log(e)
      })
    },
    tick() {
      if (this.countdown === 0) {
        this.smsDisabled = false
      } else {
        this.countdown--
        setTimeout(this.tick, 1000)
      }
    },
    handlerSendEmail(flag) {
      if (flag) {
        this.$refs.registerForm.validate(valid => {
          if (valid) {
            this.btnLoading = true;
            sendActivateCode(this.registerForm)
              .then(response => {
                if (response.status !== 200) {
                  this.$message.error(response.data.message);
                } else {
                  if (response.data.code === ERR_OK) {
                    this.emailSend = true;
                    this.getCode();
                  } else {
                    this.$message.error(response.data.message);
                  }
                }
                this.loading = false;
                this.btnLoading = false;
              })
              .catch(e => {
                this.$message.error(e.message);
                this.loading = false;
                this.btnLoading = false;
              });
          } else {
            return false;
          }
        });
      } else {
        this.btnLoading = true;
        sendActivateCode(this.registerForm)
          .then(response => {
            if (response.status !== 200) {
              this.$message.error(response.data.message);
            } else {
              if (response.data.code === ERR_OK) {
                this.emailSend = true;
                this.getCode();
              } else {
                this.$message.error(response.data.message);
              }
            }
            this.btnLoading = false;
            this.loading = false;
          })
          .catch(e => {
            this.$message.error(e.message);
            this.loading = false;
            this.btnLoading = false;
          });
      }
    },
    handlerCloseDialog() {
      this.dialogRegisteredVisible = false
      setTimeout(function() {
        vm.$router.push({
          path: "/login"
        });
      }, 0);
    },
    handlerRegister() {
      const user = this.registerForm.mobile ? `+86${this.registerForm.mobile}` : this.registerForm.email
      if (this.registerForm.verifyCode) {
        this.btnLoading = true;
        register({
          email: user,
          password: this.registerForm.password,
          checkPass: this.registerForm.checkPass,
          verifyCode: this.registerForm.verifyCode
        }).then(response => {
          if (response.status !== 200) {
            this.$message.error(response.data.message);
          } else {
            if (response.data.code === ERR_OK) {
              if (this.registerForm.mobile) {
                this.dialogRegisteredVisible = true
              } else {
                this.$message.success(vm.$t("lang.loginPage25"));
                setTimeout(function() {
                  vm.$router.push({
                    path: "/login"
                  });
                }, 2000);
              }
            } else {
              this.$message.error(response.data.message);
            }
          }
          this.loading = false;
          this.btnLoading = false;
        })
        .catch(e => {
          this.$message.error(e.message);
          this.loading = false;
          this.btnLoading = false;
        });
      } else {
        this.$message.error(vm.$t("lang.loginPage26"));
        return false;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
@import "~styles/variables.scss";
@import "~styles/mixin.scss";
.steps {
  width: 570px;
  height: 35px;
  position: relative;
  margin: 50px auto;
  .steps-line-box {
    width: 100%;
    height: 2px;
    position: absolute;
    top: 50%;
    margin-top: -1px;
    background-color: #bebebe;
    .steps-line {
      position: absolute;
      width: 0%;
      height: 2px;
      background-color: #b8e986;
    }
  }
  .steps-ul {
    position: relative;
    z-index: 2;
    li {
      display: inline-block;
      float: left;
      width: 116px;
      height: 31px;
      line-height: 31px;
      border: 2px solid #bebebe;
      background-color: #fff;
      color: #bebebe;
      border-radius: 20px;
      text-align: center;
      margin-left: 30px;
    }
    li:nth-child(1) {
      margin-left: 0px;
    }
    li.active {
      background-color: #b8e986;
      border: 2px solid #b8e986;
      color: #fff;
    }
  }
}
.user-form {
  width: 998px;
  height: 598px;
  position: absolute;
  border: 1px solid #dedede;
  top: 50%;
  left: 50%;
  margin: -300px 0px 0px -500px;
  background-color: $white;
  border-radius: 6px;
}
.user-form-img {
  width: 348px;
  height: 225px;
  float: left;
  margin: 67px 76px;
  img {
    display: block;
    width: 100%;
    line-height: 0;
    border: 0;
  }
}
.form-box {
  width: 360px;
  margin: 40px 100px 40px 0px;
  float: right;
  .title-logo {
    display: block;
    width: 155px;
    height: 58px;
    margin: 40px auto 20px;
  }
  h2 {
    color: $baseColor;
    font-size: 30px;
    text-align: center;
    margin-bottom: 50px;
  }
  .form-group {
    width: 285px;
    height: 36px;
    background: #f5f5f5;
    border-radius: 20px;
    input {
      width: 100%;
      height: 36px;
      line-height: 36px;
      text-indent: 20px;
      background: transparent;
      border: 0;
      outline: none;
    }
  }
  .btn {
    width: 285px;
    margin: 0 auto 50px;
  }
  p {
    text-align: center;
    font-size: 18px;
    color: #1b1b1b;
    a {
      color: $baseColor;
      text-decoration: none;
    }
  }
}
.success-title {
  margin: 0px 0px 20px;
  font-size: 18px;
  color: $gray;
}
.verification-group {
  width: 320px;
  position: relative;
  margin: 0px auto 35px;
  height: 36px;
  input {
    display: block;
    width: 200px;
    height: 36px;
    line-height: 36px;
    border: none;
    background-color: #f5f5f5;
    border-radius: 20px;
    text-align: center;
    outline: none;
  }
  .get-code {
    background: #FFA438;
    border-radius: 100px;
    border: none;
    color: #FFFFFF;
    position: absolute;
    width: 100px;
    height: 36px;
    font-size: 14px;
    top: 0px;
    right: 0px;
    
  }
  .btn {
    position: absolute;
    width: 100px;
    height: 34px;
    line-height: 28px;
    top: 0px;
    right: 0px;
    margin-bottom: 0px;
  }
}
.registered-dialog  {
  /deep/ .el-dialog {
    width: 260px;
    height: 240px;
    border-radius: 16px;
    .el-dialog__header {
      display: none;
    }
    .el-dialog__body {
      padding: 40px;
    }
    .dialog-content {
      height: 160px;
      width: 180px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-between;
      .logo {
        display: flex;
        justify-content: center;
        .el-icon-success {
          font-family: PingFangSC-Regular;
          font-size: 60px;
          color: #FFA438;
        }
      }
      .title {
        font-size: 20px;
        font-weight: 400;
        color: #737373;
        line-height: 30px;
      }
      .login-btn {
        border: none;
        background: none;
        outline: none;
        height: 24px;
        font-size: 17px;
        color: #F5A623;
        cursor: pointer;
      }
    }
  }
}
.show-pwd {
  position: absolute;
  right: 10px;
  top: 0px;
  width: 16px;
  height: 40px;
  font-size: 16px;
  cursor: pointer;
  user-select: none;

  .eye-close {
    display: block;
    width: 16px;
    height: 40px;
    background: url(~assets/images/eye-close.png) center center no-repeat;
    background-size: contain;
  }

  .eye-open {
    display: block;
    width: 16px;
    height: 40px;
    background: url(~assets/images/eye-open.png) center center no-repeat;
    background-size: contain;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/register/register.vue